import React from 'react';

import plusIcon from './assets/small-add.svg';

import './styles.css';

const AddNoteButton = ({openAddNoteForm}) => (
  <div
    className="AddNoteButton colab-bold colab-clickable colab-centered"
    onClick={openAddNoteForm}>
    <img src={plusIcon} alt="Add Note" />
    <div className="message">Add a note</div>
  </div>
);

export default AddNoteButton;
